var fullw = true;

$(document).ready(function () {
  if ($(window).width() < 600) {
    fullw = false;

    for (var i = 1; i < 200; i++) {
      $cinza = $("#cinza-" + i);
      $padrao = $("#padrao-" + i);

      if ($padrao.length) {
        $cinza.addClass("oculto");
        $padrao.removeClass("oculto");
      }
    }
  }
});

function ovrLogo(idx, over) {
  if (fullw) {
    $cinza = $("#cinza-" + idx);
    $padrao = $("#padrao-" + idx);

    if (over) {
      $cinza.addClass("oculto");
      $padrao.removeClass("oculto");
    } else {
      $cinza.removeClass("oculto");
      $padrao.addClass("oculto");
    }
  }
}

function abrePortfolio(slug) {
  window.location.href = __BASESITE__ + "/feito-em-casa/" + slug;
}
